import React from 'react'
import { Skeleton, Button, Form, Input, Select, Row, Col, message } from 'antd'
import { FormComponent, BaseFormComponentProps } from '../../BaseComponent'
import ISpecie from '../../../interfaces/ISpecie'
import IBreed from '../../../interfaces/IBreed'
import { SearchRequest, BreedSaveRequest }from '../../../services/api/interfaces/ApiRequest'

type BreedProps = BaseFormComponentProps & {
  uuid?: string,
  data?: IBreed,
  error: any | null,

  species: ISpecie[] | null,

  loading: boolean,
  contentLoading: boolean,
  history: any,

  loadBreed: (args: SearchRequest) => void,
  loadSpecies: (args: SearchRequest) => void,

  dispatchCreate: (args: BreedSaveRequest) => Promise<any>,
  dispatchUpdate: (args: BreedSaveRequest) => Promise<any>
}

export default class Breed extends FormComponent<BreedProps> {

  static defaultProps = {
    contentLoading: true
  }

  state = {
    saving: false,
    loaded: false
  }

  componentDidMount() {
    const { loadSpecies } = this.props

    // Check permissions
    this.validateAccessPermissions()

    // Load species
    loadSpecies({
      options: {
        limit: 9999
      }
    })
  }

  componentDidUpdate(prevProps: BreedProps, prevState) {
    const wasLoading = prevProps.loading && !this.props.loading
    const loading = this.props.loading || this.props.contentLoading
    let newState = Object.assign({}, this.state)

    // Check permissions
    this.validateAccessPermissions()

    // We are loaded?
    if (!this.state.loaded) {
      // If our entity was loaded or if we are creating a new one, that's means that we are loaded :P
      if ((wasLoading || !this.props.uuid) && !loading) {
        newState.loaded = true
      } 

      // Load breed by uuid
      if (this.props.uuid && !newState.loaded && !loading) {
        this.props.loadBreed({
          search: {
            uuid: this.props.uuid,
            specie: {
              with: true
            }
          }
        })
      }
    } else {
      // We are saving
      if (this.state.saving && wasLoading) {
        // Add the new role name to url
        if (!this.props.uuid && this.props.data) {
          this.props.history.replace(`/admin/breed/${this.props.data.uuid}`)
        }

        if (!this.props.error) {
          message.success('Breed saved successfully!')
        } else {
          message.error('Failed to save user. Error: ' + this.props.error)
        }

        newState.saving = false
      }
    }

    // Update if changed
    if (newState.loaded !== this.state.loaded) {
      this.setState(newState)
    }
  }

  handleSave = (values: any) => {
    const { uuid, dispatchCreate, dispatchUpdate } = this.props

    let payload: BreedSaveRequest = {
      breed: {
        ...values
      }
    }

    if (uuid) {
      payload = {
        breed: {
          ...payload.breed,
          uuid
        }
      }
      
      dispatchUpdate(payload)
      this.setState({
        saving: true
      })
    } else {
      dispatchCreate(payload)
      this.setState({
        saving: true
      })
    }
  }

  render() {
    const { uuid, data, species, loading } = this.props
    const { loaded } = this.state

    if (!loaded) {
      return <Skeleton />
    }

    // Species options
    const speciesOptions = species?.map(specie => {
      return {
        label: specie.name,
        value: specie.uuid
      }
    })

    let values:any = {
      name: ''
    }

    if (uuid) {
      values = {
        ...data || {}
      }
    }

    return (
      <Form
        name="breed"
        initialValues={values}
        layout="vertical"
        onFinish={this.handleSave}
      >
        <Row gutter={24}>
          <Col xs={24} md={12}>
            <Form.Item
              label="Name"
              name="name"
              rules={[
                {
                  required: true,
                  message: 'Missing a name for the breed'
                }
              ]}
            >
              <Input />
            </Form.Item>
          </Col>

          <Col xs={24} md={12}>
            <Form.Item
              label="Species"
              name={['specie', 'uuid']}
              rules={[
                {
                  required: true,
                  message: 'Missing a specie for the breed'
                }
              ]}
            >
              <Select
                placeholder="Select a species"
                options={speciesOptions}
              />
            </Form.Item>
          </Col>
        </Row>
        
        <Form.Item style={{marginTop: 32}}>
          <Button type="primary" htmlType="submit" size="large" loading={loading} ref={(refs) => this.actionRefs.save = refs} block>
            Save
          </Button>
        </Form.Item>
      </Form>
    )
  }
}